<template>  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Telemetrias de {{data_inicio_cabecalho}} à {{data_fim_cabecalho}}</h4>
          </div>
          <div class="row">
            <p class="bg-warning btn-round text-white col-md-12" id="error_data" style="display:none">A data selecionada não é uma data valida</p>
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_inicio)" v-model="data_inicio">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_fim)" v-model="data_fim">
            <n-button type="primary" class="btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile " v-on:click.native="filtrar" style="height:30px;margin-left: 20px;padding:0;margin-top:0;">Filtrar</n-button>
          </div>

          <div class="mb-3">
            <div v-for="log of logs" class="row py-2 px-2 bordered-block-table only-mobile">
              <div class="col-12">
                <span style="color: #888; font-size: 10px;">Data e hora: {{ log.data | moment("DD/MM/YYYY") }} {{ log.hora }}</span>
                <br>
                <span style="color: #888; font-size: 10px;" v-if="log.usuarioObject && log.usuarioObject.codigo  > 1">Usuário: {{ log.usuarioObject.nome }}</span>
              </div>
              <div class="col-12 mt-1">
                Ação: {{ log.acao }}
              </div>
            </div>
          </div>      
          <table class="display responsive nowrap table table-hover table-striped hidden-mobile">
            <thead>
              <tr>
                <th>Data e Hora</th>
                <th class="text-left">Usuário</th>
                <th class="text-left pr-4">Ação</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log of logs">
                <td class="text-left">{{ log.data | moment("DD/MM/YY") }} {{ log.hora }}</td>
                <td class="text-left">{{ (log.usuarioObject && log.usuarioObject.codigo > 1) ? log.usuarioObject.nome : "" }}</td>
                <td class="text-left pr-3">{{ log.acao }}</td>
              </tr>
              <tr v-if="!logs || !logs.length">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-12 col-md-6 text-center-mobile">
              Mostrando de {{ from }} até {{ to }} de {{ total}} registros
            </div>
            <div class="col-12 col-md-6 text-right text-center-mobile mt-2-mobile">
              <paginate
                :pageCount="pageCount"
                :clickHandler="changePage"
                :prevText="'Ante.'"
                :nextText="'Próx.'"
                :containerClass="'pagination'">
              </paginate>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import jQuery from 'jquery'
  import {
    Card,
    AnimatedNumber,
    Progress as NProgress,
    LineChart
  } from 'src/components'
import { setInterval } from 'timers';
import {Table, TableColumn} from 'element-ui'
import HeaderChart from '../Dashboard/HeaderChart'
import moment from 'moment'
import GlobalFunctions from '../../../globalFunctions.js'
import LogService from '@/services/LogService.js'

export default {
    components: {
      Card,
      AnimatedNumber,
      LineChart,
      NProgress,
      HeaderChart,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      moment
    },
    data() {
      return {
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        data_inicio_cabecalho:moment().format("DD/MM/YYYY"),
        mobile:GlobalFunctions.isMobile(),
        logs: [],
        data_invalida:null,
        from: 0,
        to: 0,
        total: 0,
        current_page: 1,
        pageCount: 0,
      }
    },
    methods:{

      changePage(page) {
        this.current_page = page
        this.loadLogs()
      },
      verificaData(data) {
        let data_formatada = new Date(data);
        if(data_formatada == 'Invalid Date'){
          jQuery('#error_data').show();
        }else{
          jQuery('#error_data').hide();
        }
      },


      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        this.loadLogs();
      },
      loadLogs() {
        let loader = this.$loading.show();

        LogService.load(`?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}&page=${this.current_page}`).then(res => {
          this.pageCount = res.data.last_page;
          this.logs = res.data.data;
          this.from = res.data.from;
          this.to = res.data.to;
          this.total = res.data.total;

          loader.hide()
        }).catch(err => {
          loader.hide()
        })
      },
    },
    mounted() {
      this.loadLogs()
    }
}
</script>